<app-data-table
  [cols]="cols"
  [expansionRow]="expansion"
  [loading]="loading$ | async"
  [rightActionsTemplate]="dateRangeSelect"
  [selectedCols]="selectedCols"
  [tableRows]="tableRows$"
  [translationScope]="'form-submission-chart-table'"
>
  <ng-container appDataTableColumnDef="isLatestVersion">
    <td *appDataTableCell="let row">
      <app-status-badge *ngIf="row.isLatestVersion" [color]="statusBadgeColor">Latest</app-status-badge>
    </td>
  </ng-container>
  <ng-template #expansion let-data>
    <div class="chart-table-expansion">
      <app-form-submission-chart
        [formSchema]="data.formSchema"
        [submissionData]="data.submissionData"
      ></app-form-submission-chart>
    </div>
  </ng-template>
</app-data-table>

<ng-template #dateRangeSelect>
  <app-date-range-select [formControl]="dateRange"></app-date-range-select>
</ng-template>
